import styled from 'styled-components';
import { Alert as MuiAlert } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(MuiAlert) `
  && {
    align-items: flex-start;
    border-radius: ${theme.spacing.xs};
    color: ${theme.colors.text};
    padding: ${theme.spacing.sm} ${theme.spacing.md};
  }

  &.MuiAlert-standardError {
    background: ${theme.colors.errorBackground};

    .MuiAlert-icon {
      color: ${theme.colors.errorForeground};
    }
  }

  &.MuiAlert-standardSuccess {
    background: ${theme.colors.successBackground};

    .MuiAlert-icon {
      color: ${theme.colors.successForeground};
    }
  }

  &.MuiAlert-standardInfo {
    background: ${theme.colors.infoBackground};

    .MuiAlert-icon {
      color: ${theme.colors.infoForeground};
    }
  }

  &.MuiAlert-standardWarning {
    background: ${theme.colors.warningBackground};

    .MuiAlert-icon {
      color: ${theme.colors.warningForeground};
    }
  }

  .MuiAlert-icon {
    height: 24px;
    margin-right: ${theme.spacing.sm};
    opacity: 1;
    padding: 0;
    width: 24px;

    svg {
      height: 24px;
      width: 24px;
    }
  }

  .MuiAlertTitle-root {
    ${theme.typography.headingXS};
    line-height: 24px;
    margin-block: 0;
  }

  .MuiAlert-message {
    ${theme.typography.bodyLG};
    padding: 0;
  }

  .MuiAlert-action {
    cursor: pointer;
    min-height: 24px;
    min-width: 24px;
    margin-right: 0;
    padding: 3px;

    svg {
      height: 18px;
      width: 18px;
    }
  }
`;
